import logo from "./logo.svg";
import { Routes, BrowserRouter, Route } from "react-router-dom";
import "./App.css";
import Home from "./Page/Home/Home";
import Footer from "./components/Footer";
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
